(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
  (function () {
    var popups = document.querySelectorAll('[data-promo-popup]');
    if (!popups.length) return;

    popups.forEach(function (popup) {
      var delay = parseInt(popup.getAttribute('data-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 5;

      var closers = popup.querySelectorAll('[data-promo-popup-close]');
      var firstField = popup.querySelector('input[type="text"], input[type="email"]');

      function open() {
        popup.hidden = false;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('promo-popup--open');
        if (firstField) {
          window.setTimeout(function () { firstField.focus({ preventScroll: true }); }, 50);
        }
      }

      function close() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        popup.hidden = true;
        document.body.classList.remove('promo-popup--open');
      }

      closers.forEach(function (el) { el.addEventListener('click', close); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
      });

      var isSuccessState = !!popup.querySelector('.promo-popup__title--success');

      // Form just submitted successfully — show thank-you briefly, then auto-close
      if (isSuccessState) {
        open();
        window.setTimeout(close, 4000);
        return;
      }

      window.setTimeout(open, delay * 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
